/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

import { useForm, useFormState } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

import { AddTestCasesContext } from '@qality/common-components/src/lib/AddTestCasesProvider';
import { SpinnerLoader } from '@qality/common-components/src/molecules/SpinnerLoader';
import { StorageOfUniqueServices } from '@qality/common-service';

import { SelectIssuesWrapperStyled } from './SelectIssues.styled';
import SelectIssuesView from './SelectIssues.view';

const SelectIssues = () => {
  const { change } = useForm();
  const { values } = useFormState();
  const { availableIssues, addingTestCasesLength, isAddingTestCases } =
    React.useContext(AddTestCasesContext);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    change(
      'issues',
      values.issues.map((i) => ({ ...i, isChecked }))
    );
  };

  const isAllChecked = !values.issues?.some((i) => !i.isChecked);

  useEffect(() => {
    change(
      'issues',
      availableIssues.map((i) => ({
        ...i,
        issueLink: StorageOfUniqueServices.get('URLService').getIssueURL(i.key),
        isChecked: true,
      }))
    );
  }, []);

  return (
    <SelectIssuesWrapperStyled>
      {isAddingTestCases ? (
        <SpinnerLoader
          size='large'
          shouldHideContent
          text={`We are adding ${addingTestCasesLength} Test Cases to Test Cycle...`}
        />
      ) : (
        <FieldArray name='issues'>
          {({ fields }) => (
            <SelectIssuesView
              onSelectAll={handleSelectAll}
              isAllChecked={isAllChecked}
              issues={values.issues}
              fields={fields}
            />
          )}
        </FieldArray>
      )}
    </SelectIssuesWrapperStyled>
  );
};

export default SelectIssues;
